<template>
    <div class="md-lazy" :class="moduleName">
        <div class="loading-box" role="status" aria-label="loading">
            <div class="loading-anim" aria-hidden="true"></div>
            <div class="loading-text" aria-hidden="true"></div>
        </div>
    </div>
</template>

<script>
import util from '../common/util';
import Data from '../common/data';
export default {
    props: ['moduleName', 'noObserve', 'hasLoadingPs', 'csr'],
    watch: {
        noObserve(value) {
            !this.csr && value && this.$emit('visible');
        },
        hasLoadingPs(value) {
            !this.csr && !value && this.$emit('visible');
        }
    },
    mounted() {
        // this.$el.module = this;
        var onVisible = () => {
            this.$emit('visible');
        };
        if (this.noObserve) {
            // 正常情况下, 页面加载时, 只加载首屏模块, 滑动滚动条就加载看得到的模块
            // 全局关闭了lazyMode, 就是只要用户有操作就加载剩余的模块(哪怕看不到)
            // 全局moduleNoLazy为true, 表示在页面访问时就加载所有模块
            (Data.moduleNoLazy
                ? Promise.resolve()
                : util.getUserActionPs()
            ).then(onVisible);
        }
        util.getObserver(this.$el, onVisible);
    }
};
</script>

<style lang="scss">
.md-lazy {
    width: 100%;
    height: 300px;
    position: relative;
    &.md-header {
        height: 60px;
        .loading-text {
            display: none;
        }
    }
    &.md-search,
    &.md-hero {
        height: 100vh;
    }
}
</style>
